import { array as codecArray } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, paginated, requestParams } from '@codegrade/api-core';
import { OAuthToken, PostOAuthTokenData, SetupOAuthResult } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function oauthToken(config) {
    const postResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(SetupOAuthResult)),
    });
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(OAuthToken))),
    });
    const deleteResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(OAuthToken)),
    });
    return Object.freeze({
        /**
         * Create an OAuth token for the specified provider.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns The OAuth callback URL.
         */
        post: async ({ requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/oauth_tokens/`, postResponse.v, JSON.stringify(PostOAuthTokenData.encode(requestBody)));
            return result;
        },
        /**
         * Get all OAuth tokens of the current user.
         *
         * @param arg The arguments to the function.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns The token.
         */
        getAll: async ({ pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/oauth_tokens/`, getAllResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Delete an OAuth token.
         *
         * @param arg The arguments to the function.
         * @param arg.tokenId The id of the token you want to delete.
         * @returns Nothing.
         */
        delete: async ({ tokenId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/oauth_tokens/${tokenId}`, deleteResponse.v, undefined);
            return result;
        },
        /**
         * Get an OAuth token by id.
         *
         * @param arg The arguments to the function.
         * @param arg.tokenId The id of the token to get.
         * @param arg.isTempId Whether the id in the request is a `temp_id` or an `id`.
         * @returns The requested token.
         */
        get: async ({ tokenId, isTempId = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/oauth_tokens/${tokenId}`, getResponse.v, undefined, {
                is_temp_id: isTempId,
            });
            return result;
        },
    });
}
